/* tslint:disable */
/* eslint-disable */
/**
 * Project Freelancer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { AwaitingClientPaymentResource } from './';
import {
    AwaitingClientPaymentResourceFromJSON,
    AwaitingClientPaymentResourceFromJSONTyped,
    AwaitingClientPaymentResourceToJSON,
} from './';
import type { AwaitingDeliverableValidationResource } from './';
import {
    AwaitingDeliverableValidationResourceFromJSON,
    AwaitingDeliverableValidationResourceFromJSONTyped,
    AwaitingDeliverableValidationResourceToJSON,
} from './';
import type { AwaitingFreelancerComplianceResource } from './';
import {
    AwaitingFreelancerComplianceResourceFromJSON,
    AwaitingFreelancerComplianceResourceFromJSONTyped,
    AwaitingFreelancerComplianceResourceToJSON,
} from './';
import type { CompletedPaymentResource } from './';
import {
    CompletedPaymentResourceFromJSON,
    CompletedPaymentResourceFromJSONTyped,
    CompletedPaymentResourceToJSON,
} from './';
import type { Currency } from './';
import {
    CurrencyFromJSON,
    CurrencyFromJSONTyped,
    CurrencyToJSON,
} from './';
import type { DeliverablePaymentStatus } from './';
import {
    DeliverablePaymentStatusFromJSON,
    DeliverablePaymentStatusFromJSONTyped,
    DeliverablePaymentStatusToJSON,
} from './';
import type { FinancingAcceptedPaymentResource } from './';
import {
    FinancingAcceptedPaymentResourceFromJSON,
    FinancingAcceptedPaymentResourceFromJSONTyped,
    FinancingAcceptedPaymentResourceToJSON,
} from './';
import type { FinancingAskedPaymentResource } from './';
import {
    FinancingAskedPaymentResourceFromJSON,
    FinancingAskedPaymentResourceFromJSONTyped,
    FinancingAskedPaymentResourceToJSON,
} from './';
import type { FinancingBlockedPaymentResource } from './';
import {
    FinancingBlockedPaymentResourceFromJSON,
    FinancingBlockedPaymentResourceFromJSONTyped,
    FinancingBlockedPaymentResourceToJSON,
} from './';
import type { FinancingRefusedPaymentResource } from './';
import {
    FinancingRefusedPaymentResourceFromJSON,
    FinancingRefusedPaymentResourceFromJSONTyped,
    FinancingRefusedPaymentResourceToJSON,
} from './';
import type { OverduePaymentResource } from './';
import {
    OverduePaymentResourceFromJSON,
    OverduePaymentResourceFromJSONTyped,
    OverduePaymentResourceToJSON,
} from './';

/**
 * 
 * @export
 * @interface ProjectDeliverablePaymentResource
 */
export interface ProjectDeliverablePaymentResource {
    /**
     * 
     * @type {DeliverablePaymentStatus}
     * @memberof ProjectDeliverablePaymentResource
     */
    status: DeliverablePaymentStatus;
    /**
     * 
     * @type {number}
     * @memberof ProjectDeliverablePaymentResource
     */
    amountInclTaxes: number;
    /**
     * 
     * @type {Currency}
     * @memberof ProjectDeliverablePaymentResource
     */
    currency: Currency;
}

/**
 * Check if a given object implements the ProjectDeliverablePaymentResource interface.
 */
export function instanceOfProjectDeliverablePaymentResource(value: object): value is ProjectDeliverablePaymentResource {
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('amountInclTaxes' in value) || value['amountInclTaxes'] === undefined) return false;
    if (!('currency' in value) || value['currency'] === undefined) return false;
    return true;
}

export function ProjectDeliverablePaymentResourceFromJSON(json: any): ProjectDeliverablePaymentResource {
    return ProjectDeliverablePaymentResourceFromJSONTyped(json, false);
}

export function ProjectDeliverablePaymentResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProjectDeliverablePaymentResource {
    if (json == null) {
        return json;
    }
    if (!ignoreDiscriminator) {
        if (json['status'] === 'AWAITING_CLIENT_PAYMENT') {
            return AwaitingClientPaymentResourceFromJSONTyped(json, true);
        }
        if (json['status'] === 'AWAITING_DELIVERABLE_VALIDATION') {
            return AwaitingDeliverableValidationResourceFromJSONTyped(json, true);
        }
        if (json['status'] === 'AWAITING_FREELANCER_COMPLIANCE') {
            return AwaitingFreelancerComplianceResourceFromJSONTyped(json, true);
        }
        if (json['status'] === 'COMPLETED_PAYMENT') {
            return CompletedPaymentResourceFromJSONTyped(json, true);
        }
        if (json['status'] === 'FINANCING_ACCEPTED_PAYMENT') {
            return FinancingAcceptedPaymentResourceFromJSONTyped(json, true);
        }
        if (json['status'] === 'FINANCING_ASKED_PAYMENT') {
            return FinancingAskedPaymentResourceFromJSONTyped(json, true);
        }
        if (json['status'] === 'FINANCING_BLOCKED_PAYMENT') {
            return FinancingBlockedPaymentResourceFromJSONTyped(json, true);
        }
        if (json['status'] === 'FINANCING_REFUSED_PAYMENT') {
            return FinancingRefusedPaymentResourceFromJSONTyped(json, true);
        }
        if (json['status'] === 'OVERDUE_PAYMENT') {
            return OverduePaymentResourceFromJSONTyped(json, true);
        }
    }
    return {
        
        'status': DeliverablePaymentStatusFromJSON(json['status']),
        'amountInclTaxes': json['amountInclTaxes'],
        'currency': CurrencyFromJSON(json['currency']),
    };
}

export function ProjectDeliverablePaymentResourceToJSON(value?: ProjectDeliverablePaymentResource | null, ignoreDiscriminator?: boolean): any {
    if (value == null) {
        return value;
    }
    if (!ignoreDiscriminator) {
        if (value.status === 'AWAITING_CLIENT_PAYMENT') {
            return AwaitingClientPaymentResourceToJSON(value as AwaitingClientPaymentResource);
        }
        if (value.status === 'AWAITING_DELIVERABLE_VALIDATION') {
            return AwaitingDeliverableValidationResourceToJSON(value as AwaitingDeliverableValidationResource);
        }
        if (value.status === 'AWAITING_FREELANCER_COMPLIANCE') {
            return AwaitingFreelancerComplianceResourceToJSON(value as AwaitingFreelancerComplianceResource);
        }
        if (value.status === 'COMPLETED_PAYMENT') {
            return CompletedPaymentResourceToJSON(value as CompletedPaymentResource);
        }
        if (value.status === 'FINANCING_ACCEPTED_PAYMENT') {
            return FinancingAcceptedPaymentResourceToJSON(value as FinancingAcceptedPaymentResource);
        }
        if (value.status === 'FINANCING_ASKED_PAYMENT') {
            return FinancingAskedPaymentResourceToJSON(value as FinancingAskedPaymentResource);
        }
        if (value.status === 'FINANCING_BLOCKED_PAYMENT') {
            return FinancingBlockedPaymentResourceToJSON(value as FinancingBlockedPaymentResource);
        }
        if (value.status === 'FINANCING_REFUSED_PAYMENT') {
            return FinancingRefusedPaymentResourceToJSON(value as FinancingRefusedPaymentResource);
        }
        if (value.status === 'OVERDUE_PAYMENT') {
            return OverduePaymentResourceToJSON(value as OverduePaymentResource);
        }
    }
    return {
        
        'status': DeliverablePaymentStatusToJSON(value['status']),
        'amountInclTaxes': value['amountInclTaxes'],
        'currency': CurrencyToJSON(value['currency']),
    };
}

